/**
 *  @class
 *  @function MediaWithTabs
 */
if (!customElements.get("media-with-tabs")) {
	class MediaWithTabs extends HTMLElement {
		constructor() {
			super()
		}
		connectedCallback() {
			this.buttons = Array.from(
				this.querySelectorAll(".media-with-tabs--button")
			)
			this.slider = this.querySelector("slide-show")
			this.buttons.forEach((button, i) => {
				button.addEventListener("click", () => {
					this.buttonClick(button, i)
				})
			})
		}
		buttonClick(button, i) {
			let flkty = Flickity.data(this.slider)
			;[].forEach.call(this.buttons, function (el) {
				el.parentElement.classList.remove("active")
			})
			let parent = button.parentElement
			let text = parent.querySelector(".media-with-tabs--text")
			parent.classList.add("active")
			setTimeout(() => {
				if (text.scrollHeight > 200) text.classList.add("show-more")
			}, 300)
			flkty.select(i)
		}
	}
	customElements.define("media-with-tabs", MediaWithTabs)
}
